import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import { thunk } from 'redux-thunk';
import rootReducer from "../src/store/reducers/index"
import ToastHandler from "./shared/common/toastHandler";

// Production builds keep warnings and errors; the debug channels go quiet so
// stray development logging never reaches end users.
if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
}

const root = createRoot(document.getElementById('root'));

// Server state is refetched on load, so nothing needs to survive a refresh —
// the previous redux-persist layer ran with an empty whitelist and stored
// nothing anyway.
const store = createStore(
  rootReducer,
  applyMiddleware(thunk)
);

root.render(
  // <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <App />
        <ToastHandler />
      </Provider>
    </BrowserRouter>
  // </React.StrictMode>
);
